var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackendDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.963 120.886C67.0134 91.0175 91.2927 66.7723 121.074 66.8734C150.956 66.9744 175.135 91.2532 175 121.055C174.882 150.906 150.738 174.983 120.973 174.983C91.1413 174.983 66.9125 150.704 66.963 120.886ZM142.611 120.836C142.106 121.374 141.753 121.779 141.382 122.149C137.311 126.24 133.205 130.315 129.15 134.406C126.896 136.696 126.778 139.912 128.831 142.016C130.917 144.172 134.215 144.104 136.537 141.781C142.173 136.174 147.81 130.551 153.413 124.91C155.852 122.452 155.852 119.405 153.413 116.946C147.776 111.255 142.106 105.598 136.419 99.9579C134.198 97.7522 130.85 97.7354 128.814 99.8232C126.812 101.877 126.879 105.093 129.016 107.316C130.345 108.696 131.708 110.026 133.054 111.356C136.217 114.488 139.38 117.637 142.594 120.819L142.611 120.836ZM99.2849 120.987C99.7897 120.448 100.143 120.061 100.53 119.674C104.568 115.633 108.623 111.592 112.661 107.534C114.983 105.194 115.135 101.928 113.048 99.8064C110.962 97.6849 107.647 97.8028 105.325 100.093C99.6887 105.699 94.069 111.34 88.4661 116.98C86.0432 119.421 86.0768 122.452 88.5165 124.927C90.7375 127.183 92.9753 129.406 95.2131 131.645C98.6792 135.113 102.112 138.615 105.628 142.033C108.472 144.795 113.082 143.717 114.243 140.047C114.933 137.891 114.377 135.989 112.745 134.373C108.287 129.978 103.861 125.533 99.3017 120.987H99.2849Z",
    fill: "url(#paint0_linear_106_332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3197 63.4387C69.7897 63.2199 57.0527 62.3107 44.585 59.0948C39.4532 57.7815 34.456 56.0642 30.1486 52.8652C27.4902 50.8784 25.4374 48.4707 25.1514 44.9687C24.7981 40.7426 27.0022 37.813 30.1654 35.4726C35.0785 31.819 40.816 30.0512 46.6545 28.7379C62.0162 25.2358 77.5799 24.4613 93.2445 25.32C103.424 25.8756 113.553 26.97 123.312 30.0343C126.711 31.095 129.992 32.644 133.188 34.2435C134.753 35.018 136.167 36.2808 137.378 37.5773C141.181 41.6518 141.096 46.8544 137.277 50.9289C134.198 54.1953 130.227 55.98 126.105 57.4448C118.264 60.2397 110.104 61.5698 101.842 62.3443C95.4487 62.9336 89.0213 63.203 85.3028 63.4387H85.3197Z",
    fill: "url(#paint1_linear_106_332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3853 73.7598C73.6764 77.043 70.9675 80.1074 68.5109 83.3569C64.8598 88.2227 62.134 93.6106 60.1486 99.3688C59.8626 100.177 59.6607 100.8 58.5165 100.682C49.1447 99.7055 39.8065 98.4933 30.8385 95.4289C25 93.4254 25 93.3917 25 87.2125C25 79.5181 25 71.8404 25 64.146C25 63.5735 25 63.0011 25 62.2266C41.1021 71.5374 58.7185 72.8843 76.3853 73.7598Z",
    fill: "url(#paint2_linear_106_332)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0674 104.269C35.4656 108.36 46.234 109.724 57.1538 110.986C55.4375 122.991 56.7836 134.508 61.5284 146.108C55.9928 145.064 50.8442 144.239 45.7797 143.111C41.0012 142.051 36.3237 140.552 32.1173 137.926C30.4684 136.898 28.9541 135.619 27.5744 134.255C26.0264 132.723 25.101 130.753 25.0842 128.547C25.0337 120.55 25.0674 112.535 25.0674 104.269Z",
    fill: "url(#paint3_linear_106_332)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_332",
    x1: 120.982,
    y1: 66.873,
    x2: 120.982,
    y2: 174.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_332",
    x1: 82.6502,
    y1: 24.999,
    x2: 82.6502,
    y2: 63.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_332",
    x1: 50.6927,
    y1: 62.2266,
    x2: 50.6927,
    y2: 100.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_332",
    x1: 43.2924,
    y1: 104.269,
    x2: 43.2924,
    y2: 146.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendDev);
export default __webpack_public_path__ + "static/media/Backend_Dev.ccbef554bd81494006e8cf35acf0ac91.svg";
export { ForwardRef as ReactComponent };